import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatCheckboxChange, MatDialogRef, MatRadioChange } from '@angular/material';
import { EditContactComponent } from '../edit-contact/edit-contact.component';
import { hasTag} from '../../util/tag-utils';
import { Business } from '../models/business.model';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { TagService } from '../../shared/services/tag.service';
import { FlyingClub } from '../models/flying-club.model';

@Component({
  selector: 'app-edit-club-details',
  templateUrl: './edit-club-details.component.html',
  styleUrls: ['./edit-club-details.component.scss']
})

export class EditClubDetailsComponent implements OnInit {

  formGroup: FormGroup;
  business: Business;
  orgType: string;
  isAvailable: boolean;
  hasWaitingList: boolean;
  isLoading = false;
  memberSizePlaceHolder = 'Average Membership Size';
  _equityClubTag = 'Flying Club::Equity Club';
  _nonEquityClubTag = 'Flying Club::Non-Equity Club';
  _hybridEquityClubTag = 'Flying Club::Hybrid-Equity Club';
  _membershipAvailTag = 'Flying Club::Membership::Open';
  _membershipWaitingListTag = 'Flying Club::Membership::Waiting List';
  _originalClubData: FlyingClub;
  constructor(private _matDialogRef: MatDialogRef<EditContactComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _businessManagerService: BusinessManagerService,
              private _tagService: TagService) {
   this.business = data.business;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close(null);
    });
    this._originalClubData = Object.assign(new FlyingClub(), this.business.flyingClub);
    this.formGroup = new FormGroup({
      orgType: new FormControl(''),
      aveNumMembers: new FormControl(''),
      numOfAC: new FormControl(''),
      membershipsAvail: new FormControl('')
    });
    if (hasTag(this.business.tags, this._hybridEquityClubTag)) {
      this.orgType = '3';
    } else if (hasTag(this.business.tags, this._equityClubTag)) {
      this.orgType = '1';
    } else {
      this.orgType = '2';
    }
    this.isAvailable = hasTag(this.business.tags, this._membershipAvailTag);
    this.hasWaitingList = hasTag(this.business.tags, this._membershipWaitingListTag);
  }

  orgTypeChanged(radioChange: MatRadioChange) {
    this.orgType = radioChange.source.value;
  }

  membershipChanged(radioChange: MatRadioChange) {
    if (radioChange.source.value === '1' && !this.isAvailable) {
      this.isAvailable = true;
      this.hasWaitingList = false;
    } else if (radioChange.source.value === '2' && this.isAvailable) {
      this.isAvailable = false;
    }
  }

  waitingListChecked(checkbox: MatCheckboxChange) {
    if (checkbox.checked) {
      this.hasWaitingList = true;
    } else {
      this.hasWaitingList = false;
    }
  }

  aveMemberUnfocussed() {
    const MEMBERS = this.business.flyingClub.clubMembers;
    this.business.flyingClub.clubMembers =  (!MEMBERS || MEMBERS < 0) ? 0 : Math.floor(MEMBERS);
  }

  numOfACUnfocussed() {
    const AIRCRAFT = this.business.flyingClub.clubAircraft;
    this.business.flyingClub.clubAircraft =  (!AIRCRAFT || AIRCRAFT < 0) ? 0 : Math.floor(AIRCRAFT);
  }

  close(success: boolean) {
    if (success === null) {
      Object.assign(this.business.flyingClub, this._originalClubData);
    }
    this._matDialogRef.close(success);
  }

  async save () {
    this.isLoading = true;
    try {
      const allTags = await this._tagService.getAllTags();
      const MEMBER_AVAIL_TAG_ID = 42842;
      const MEMBER_WAITING_LIST_TAG_ID = 49285;
      const orgTypeTags = [
        {value: '1', tagName: this._equityClubTag},
        {value: '2', tagName: this._nonEquityClubTag},
        {value: '3', tagName: this._hybridEquityClubTag}
      ];
      for (const orgTypeTag of orgTypeTags) {
        const tagId = this._tagService.findTagByName(allTags, orgTypeTag.tagName).tagId;
        const hasIt = hasTag(this.business.tags, orgTypeTag.tagName);
        if (this.orgType === orgTypeTag.value && !hasIt) {
          await this._tagService.postTag(tagId, this.business.id);
        } else if (this.orgType !== orgTypeTag.value && hasIt) {
          await this._tagService.deleteTag(tagId, this.business.id);
        }
      }
      if (this.isAvailable && !hasTag(this.business.tags, this._membershipAvailTag)) {
        await this._tagService.postTag(MEMBER_AVAIL_TAG_ID, this.business.id);
      } else if (!this.isAvailable && hasTag(this.business.tags, this._membershipAvailTag)) {
        await this._tagService.deleteTag(MEMBER_AVAIL_TAG_ID, this.business.id);
      }
      if (this.hasWaitingList && !hasTag(this.business.tags, this._membershipWaitingListTag)) {
        await this._tagService.postTag(MEMBER_WAITING_LIST_TAG_ID, this.business.id);
      } else if (!this.hasWaitingList && hasTag(this.business.tags, this._membershipWaitingListTag)) {
        await this._tagService.deleteTag(MEMBER_WAITING_LIST_TAG_ID, this.business.id);
      }
      const newBusiness = await this._businessManagerService.updateBusiness(this.business);
      Object.assign(this.business, newBusiness);
    } catch (e) {
      this.close(false);
      this.isLoading = false;
      return;
    }
    this.isLoading = false;
    this.close(true);
  }
}
